module.exports = __webpack_public_path__ + "static/media/modalBackground.df886d24.png";